import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";


@Options({
    template: require("../templates/image-view.njk"),

})
export default class ImageView extends Marionette.View<Backbone.Model>{ }



// WEBPACK FOOTER //
// ./@modules/modals/views/image-view.ts